module.exports = __webpack_public_path__ + "img/BYOCS_Sleep.78b70725.jpg";